import { SuspenseLoader } from '@packages/common/components/Loader/SuspenseLoader';

export const Loading = () => {
	return <SuspenseLoader />;
};

export default Loading;
